import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@NgModule({
  declarations: [],
  imports: [CommonModule],
})
export class SvgIconsModule {
  materialIconsPath = 'assets/icons/material';

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    //#region Material
    iconRegistry.addSvgIcon(
      'account',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/account.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'account-cancel',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/account-cancel.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'account-check',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/account-check.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'account-circle',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/account-circle.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'account-clock',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/account-clock.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'account-cog',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/account-cog.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'account-eye',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/account-eye.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'account-group',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/account-group.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'account-multiple',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/account-multiple.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'add-circle',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/add-circle.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'alert',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/alert.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'alert-circle',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/alert-circle.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'alert-outline',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/alert-outline.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'apps',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/apps.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'arrow-left',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/arrow-left.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'arrow-right-alt',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/arrow-right-alt.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'arrow-right',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/arrow-right.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'attachment',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/attachment.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'autorenew',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/autorenew.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'binoculars',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/binoculars.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'box',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/box.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'briefcase-variant',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/briefcase-variant.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'calendar',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/calendar.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'calendar-month',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/calendar-month.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'cancel',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/cancel.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'card-account-details-outline',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/card-account-details-outline.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'chart-gantt',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/chart-gantt.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'chart-line',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/chart-line.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'chart-bar',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/chart-bar.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'check',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/check.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'check-circle',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/check-circle.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'chevron-double-left',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/chevron-double-left.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'chevron-double-right',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/chevron-double-right.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'chevron-left',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/chevron-left.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'chevron-right',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/chevron-right.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'arrow-circle-right',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/arrow-circle-right.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'circle-edit-outline',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/circle-edit-outline.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'clipboard-list-outline',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/clipboard-list-outline.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'clipboard-outline',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/clipboard-outline.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'clock',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/clock.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'clock-outline',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/clock-outline.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'close',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/close.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'close-circle',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/close-circle.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'cloud-download',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/cloud-download.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'cloud-download-outline',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/cloud-download-outline.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'cloud-upload',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/cloud-upload.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'cloud-upload-outline',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/cloud-upload-outline.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'cog',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/cog.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'content-copy',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/content-copy.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'content-duplicate',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/content-duplicate.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'content-save',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/content-save.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'delete-forever',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/delete-forever.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'details',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/details.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'dolly',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/dolly.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'domain',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/domain.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'dots-horizontal',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/dots-horizontal.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'download',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/download.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'drive-file-rename',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/drive-file-rename.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'eraser',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/eraser.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'error-in-time',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/error-in-time.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'eye',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/eye.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'eye-off',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/eye-off.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'file-cog',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/file-cog.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'file-edit',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/file-edit.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'file-excel',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/file-excel.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'file-import',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/file-import.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'file-pdf',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/file-pdf.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'file-plus',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/file-plus.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'file-sign',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/file-sign.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'filter',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/filter.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'filter-remove',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/filter-remove.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'folder-open',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/folder-open.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'folder-zip',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/folder-zip.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'format-align-left',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/format-align-left.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'format-list-bulleted-square',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/format-list-bulleted-square.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'format-list-group',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/format-list-group.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'fountain-pen-tip',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/fountain-pen-tip.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'fountain-pen-tip-line',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/fountain-pen-tip-line.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'gesture-draw-line',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/gesture-draw-line.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'history',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/history.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'import',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/import.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'inbox',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/inbox.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'information-outline',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/information-outline.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'information',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/information.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'lifebuoy',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/lifebuoy.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'lock',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/lock.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'lock-open-outline',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/lock-open-outline.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'lock-open-variant',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/lock-open-variant.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'lock-outline',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/lock-outline.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'logout',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/logout.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'map-marker',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/map-marker.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'map-marker-radius',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/map-marker-radius.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'menu',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/menu.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'menu-down',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/menu-down.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'message-text',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/message-text.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'sort-numeric',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/sort-numeric.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'order-bool-descending-variant',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/order-bool-descending-variant.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'open-in-full',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/open-in-full.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'open-in-new',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/open-in-new.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'palette',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/palette.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'paperclip',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/paperclip.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'pin',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/pin.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'plus',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/plus.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'quality-high',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/quality-high.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'send',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/send.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'shield-account',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/shield-account.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'tag-multiple',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/tag-multiple.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'timer-sand',
      sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/material/timer-sand.svg'
      )
    );
    iconRegistry.addSvgIcon(
      'view-grid',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/view-grid.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'view-list-outline',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/view-list-outline.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'weather-partly-cloudy',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/weather-partly-cloudy.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'wifi',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/wifi.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'wifi-off',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/wifi-off.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'window-restore',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/window-restore.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'wrench',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/wrench.svg`
      )
    );
    iconRegistry.addSvgIcon(
      'function-variant',
      sanitizer.bypassSecurityTrustResourceUrl(
        `${this.materialIconsPath}/function-variant.svg`
      )
    );

    //#endregion

    // Usage example: <mat-icon svgIcon="arrow-left" mat-list-icon></mat-icon>
  }
}
